"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopper = void 0;
var react_1 = require("react");
var core_1 = require("@popperjs/core");
var useClickOutside_1 = require("../hooks/useClickOutside");
var usePopper = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.distance, distance = _c === void 0 ? 8 : _c, _d = _a.placement, placement = _d === void 0 ? "bottom-start" : _d, _e = _a.modifiers, modifiers = _e === void 0 ? [] : _e, _f = _a.type, type = _f === void 0 ? "click" : _f, _g = _a.onClose, onClose = _g === void 0 ? function () { } : _g;
    var popperRef = (0, react_1.useRef)(null);
    var childrenRef = (0, react_1.useRef)(null);
    var anchorRef = (0, react_1.useRef)(null);
    (0, useClickOutside_1.useClickOutside)({
        ref: childrenRef,
        onClickOutside: onClose,
        when: open,
        type: type,
    });
    (0, react_1.useEffect)(function () {
        var instance = popperRef.current;
        return function () { return instance === null || instance === void 0 ? void 0 : instance.destroy(); };
    }, []);
    (0, react_1.useLayoutEffect)(function () {
        var _a;
        if (open && childrenRef.current && anchorRef.current) {
            popperRef.current = (0, core_1.createPopper)(anchorRef.current, childrenRef.current, {
                placement: placement,
                modifiers: __spreadArray([
                    {
                        name: "offset",
                        options: {
                            offset: [0, distance],
                        },
                    }
                ], __read(modifiers), false),
            });
            anchorRef.current.blur();
            childrenRef.current.focus();
        }
        if (!open) {
            (_a = popperRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        }
    }, [open, placement, distance, modifiers]);
    return { anchorRef: anchorRef, childrenRef: childrenRef, open: open };
};
exports.usePopper = usePopper;
//# sourceMappingURL=usePopper.js.map